  <div class="modal-body">
    <csl-news-letter-widget titleText="Subscribe to the CSL Weekly Take Away!"></csl-news-letter-widget>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.dismiss('Close click')">Close</button>
  </div>